import {makeGetRequest} from "@/api/helpers";

/**
 * Get partner groups.
 */
export const getPartnerGroups = async () => {
    const result = await makeGetRequest('/api/partner-groups');

    return result.data;
};